import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class FinishToOnApproval extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.FINISH_TO_ON_APPROVAL]);
  }
}

export default FinishToOnApproval;
